/**
 * 9/2024 Note - if you don't pass a clientId to this string, it returns undefined... in other words the `append` param won't exist at all when no clientId is passed
 *
 * Returns a clientId if the provided clientId is defined, optionally appending a suffix.
 * This is used to generate client ids for multiple unique portions of a component
 * based on a provided clientId.
 */
export const getClientId = (clientId, append) => {
  if (!clientId) return undefined;
  return [clientId, append].filter(Boolean).join("-");
};
//# sourceMappingURL=getClientId.js.map